import React from 'react';
import IconFont from '@meitu/xdesign-icon-font';
import pic from '../assets/pic.png';

const Upload: React.FC<{ uploadCallback: (file: File) => void }> = ({ uploadCallback }) => {
    const fileDrop = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();

        const file = e.dataTransfer.files[0]; // 获取到第一个上传的文件对象

        if (!file) return;

        uploadCallback(file);
    };

    const fileDragover = (e: React.DragEvent) => {
        e.preventDefault();
    };

    const fileChange = (e: any) => {
        const file = e.target.files.item(0);
        if (!file) {
            return;
        }

        uploadCallback(file);
    };

    const uploadClick = () => {
        const elem = document.getElementById('uploadPsdId');
        if (!elem) {
            return;
        }

        elem.click();
    };

    return (
        <>
            <div className="upload-wrap" onDragOver={fileDragover} onDrop={fileDrop}>
                <img src={pic} alt="图片" />
                <div className="btn" onClick={uploadClick}>
                    点击上传
                </div>
                <input id="uploadPsdId" onChange={fileChange} type="file" accept=".psd,.pptx" />
                <div className="desc">
                    <span>直接拖拽或点击上传文件</span>
                    <br />
                    <span>上传PSD或PPT文件，且不超过600MB</span>
                </div>
            </div>

            <div className="upload-wrap-tip">
                <IconFont name="InfoCircleFill" fontSize={14} />
                上传后系统将自动为您建立图层，部分未成功识别图层，需手动调整
            </div>
        </>
    );
};

export default Upload;
